module.exports = __webpack_public_path__ + "img/291.020d990a.png";